module.exports = __webpack_public_path__ + "img/Vatican-City-State.28759577.png";